import { Form } from '@felicity/vision';
import './login.scss';

class LoginForm extends Form {
  getData() {
    const data = super.getData();

    // Convert checkbox's value to boolean
    if (data.rememberMe !== undefined) {
      data.rememberMe = true;
    }

    return data;
  }

  handleResponse(json) {
    const url = new URL(`${window.location.origin}/LoginWith2fa`);
    url.searchParams.append('returnUrl', this.returnTo);
    window.location.href = url.toString();
  }
}

window.customElements.define('flc-login-form', LoginForm);
